import { useContext } from "react";

import { ReportContext } from "@providers/ReportProvider/context";

export const useReport = () => {
  const context = useContext(ReportContext);
  if (context === undefined) {
    throw new Error("useReport must be used within a ReportProvider");
  }
  return context;
};

export const useReportOptional = () => useContext(ReportContext);
